export default __webpack_public_path__ + "static/media/logo-dev-concierge.1a015e0e.svg";